import React from 'react';
import { TextInput } from 'ui-toolkit';
import { createOnChangeHandlerGenerator } from '../utilities/createOnChangeHandlerGenerator';
import { CdLabelCell } from '../CdLabelCell.styles';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import IItemProps from './IItemProps';
import SharedItemCells from './SharedItemCells';
import { IOtherFeeViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

interface IOtherFee extends IItemProps, IHasItemDataProps<IOtherFeeViewItem>, IHasItemEventProps<IOtherFeeViewItem> {}

const OtherFee: React.FC<IOtherFee> = (props) => {
  const { data, onChange, hasEditPermissions } = props;
  const generateDefaultOnChangeHandler = createOnChangeHandlerGenerator(data, onChange);
  const labelOnChangeEvent = generateDefaultOnChangeHandler('label');
  const payeeOnChangeEvent = generateDefaultOnChangeHandler('payee');
  return (
    <SharedItemCells {...props} readOnly={!hasEditPermissions}>
      <CdLabelCell gridTemplateColumns={'1fr min-content 1fr'}>
        <TextInput
          onChange={labelOnChangeEvent}
          placeholder="Other Fee"
          value={data.label}
          readOnly={!hasEditPermissions}
          debounceOnValueChange
        />
        <span>to</span>
        <TextInput
          onChange={payeeOnChangeEvent}
          placeholder="Payee"
          value={data.payee}
          readOnly={!hasEditPermissions}
          debounceOnValueChange
        />
      </CdLabelCell>
    </SharedItemCells>
  );
};

export default OtherFee;
